import { axios } from "@/client/libs/axios";
import { useQuery } from "@tanstack/react-query";
import qs from "qs";

export const ExportAmbassadorXlsx = async () => {
  const filter = sessionStorage.getItem("Current_ambassador_list");
  const response = await axios.get("user/export", {
    params: qs.parse(filter!),
    paramsSerializer: (params) => qs.stringify(params),
    responseType: "blob",
  });

  const blob = new Blob([response.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "Ambassador.xlsx");
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const useExportAmbassador = () => {
  const filter = sessionStorage.getItem("Current_ambassador_list");
  const { refetch } = useQuery({
    queryKey: ["ExportAmbassador", filter],
    queryFn: ExportAmbassadorXlsx,
    enabled: false,
  });

  return { refetch };
};
